import React, { useContext, useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { Formik } from 'formik';
import {
  Box,
  Snackbar,
  Button,
  Container,
  Link,
  TextField,
  Typography,
  makeStyles
} from '@material-ui/core';

import MuiAlert from '@material-ui/lab/Alert';

import Page from 'src/components/Page';
import { Context } from '../../../services/context';


function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}


const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    height: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const Login = () => {

  const classes = useStyles();

  const [open, setOpen] = useState(false);
  const { authenticated, handleLogin } = useContext(Context);

  const navigate = useNavigate();

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  useEffect(() => {
    localStorage.removeItem('authenticateDevice');
  }, []);

  return (
    <Page
      className={classes.root}
      title="Login"
    >

      <Snackbar open={open}
        autoHideDuration={4000}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        onClose={handleClose}>
        <Alert onClose={handleClose} severity="error">
          Erro ao acessar o sistema. Nome do usuário e/ou Senha incorretos.
        </Alert>
      </Snackbar>

      <Box
        display="flex"
        flexDirection="column"
        height="100%"
        justifyContent="center"
      >
        <Container maxWidth="sm">
          <Formik

            initialValues={{
              login: '',
              password: ''
            }}

            validationSchema={Yup.object().shape({
              login: Yup.string().max(255).required('Informar o Usuário é obrigatório.'),
              password: Yup.string().max(255).required('Informar a Senha é obrigatório.')
            })}

            onSubmit={async (values, formik) => {
              await handleLogin(values);
              formik.setValues({ login: '', password: '' });
              setOpen(!authenticated);
              formik.setSubmitting(false);
            }}

          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              isSubmitting,
              touched,
              values
            }) => (
              <form onSubmit={handleSubmit}>
                <Box mb={3}>
                  <Typography
                    color="textPrimary"
                    variant="h2"
                  >
                    Acessar
                  </Typography>
                  <Typography
                    color="textSecondary"
                    gutterBottom
                    variant="body2"
                  >
                    Acessar o Sistema Integrado de Manutenção e Monitoramento
                  </Typography>
                </Box>

                <Box
                  mt={3}
                  mb={1}
                >
                  <Typography
                    align="center"
                    color="textSecondary"
                    variant="h4"
                  >
                    Entrar com nome do usuário e senha
                  </Typography>
                </Box>
                <TextField
                  error={Boolean(touched.login && errors.login)}
                  fullWidth
                  helperText={touched.login && errors.login}
                  label="Usuário"
                  margin="normal"
                  name="login"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.login}
                  variant="outlined"
                  focused="true"
                  InputLabelProps={{ shrink: true }}
                />
                <TextField
                  error={Boolean(touched.password && errors.password)}
                  fullWidth
                  helperText={touched.password && errors.password}
                  label="Senha"
                  margin="normal"
                  name="password"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  type="password"
                  value={values.password}
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                />
                <Box my={1}>
                  <Button
                    color="secondary"
                    fullWidth
                    disabled={isSubmitting}
                    size="small"
                    type="submit"
                    variant="contained"
                  >
                    Entrar
                  </Button>
                </Box>
                <Typography
                  color="textSecondary"
                  variant="body1"
                >
                  Não tenho conta?
                  {' '}
                  <Link
                    component={RouterLink}
                    to="/register"
                    variant="h6"
                  >
                    Registrar
                  </Link>
                </Typography>
              </form>
            )}
          </Formik>
        </Container>
      </Box>
    </Page>
  );
};

export default Login;
